import { Document, Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import { colors } from '@styles/vars'
import _ from 'lodash'
import React from 'react'
import CertificateFooter from './components/CertificateFooter'
import CertificateName from './components/CertificateName'
import styles from './styles'

export default function AcceptanceCertificatePdf({ salon, customer }: Props) {
    const acceptances = salon.attrs.acceptances()
    const columns = _.chunk(acceptances, 8)
    const title = acceptances.length ? `Acceptance certificate` : `Participation certificate`
    const name = `${customer.first_name} ${customer.last_name}`

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.container}>
                    <View>
                        <Text style={styles.h3}>{title}</Text>
                    </View>
                    <View>
                        <Text style={styles.p}>Confirms that</Text>
                        <CertificateName name={name} />
                        <Text style={[styles.p, styles.mgb5]}>participated in</Text>
                        <Text style={[styles.p, styles.bold]}>{salon.state.name}</Text>
                    </View>
                    {acceptances.length > 0 &&
                        <View>
                            <Text style={[styles.sm]}>Acceptances</Text>
                            <View style={[styles.hr, styles.mgb10]} />
                            <View style={ownStyles.acceptances}>
                                {columns.map((column, idx) => (
                                    <View key={idx} style={idx === 0 ? styles.column50left : styles.column50right}>
                                        {column.map(acceptance => (
                                            <Text 
                                            hyphenationCallback={word => [word]}
                                            key={acceptance.id} 
                                            style={ownStyles.acceptance}>
                                                {acceptance.photo.title}
                                            </Text>
                                        ))}
                                    </View>
                                ))}
                            </View>
                        </View>
                    }
                    <CertificateFooter salon={salon} />
                </View>
            </Page>
        </Document>
    )
}

interface Props {
    salon: Customer.Models.Salon.Stateful
    customer: Resources.Customer
}

const ownStyles = StyleSheet.create({
    acceptances: {
        flexDirection: 'row'
    },
    acceptance: {
        fontSize: '12px',
        marginBottom: '5px'
    },
    column50left: {
        width: "50%",
        paddingRight: "15px"
    },
    column50right: {
        width: "50%",
        paddingLeft: "15px"
    }
})